module.exports = "<nv-react-component component=\"CourseSupervisorDashboard\"></nv-react-component>";